<template>
  <div v-if="user" class="row navbar bg-dark">

    <!-- Menu principal -->
    <ul class="col-auto nav align-items-center">
      <li class="nav-items"><router-link class="nav-link" to="/"><i class="nav-item fs-4 bi-house" title="Accueil"></i></router-link></li>
      <li v-for="tab in user.menu" :key="tab.name" class="nav-item d-none d-sm-block">
        <router-link v-if="tab.navbar == 1" class="nav-link" :to="tab.link"><i class="nav-item fs-4" :class="tab.icon" :title="tab.label"></i></router-link>
      </li>
    </ul>
    
    <!-- Recherche rapide 
    <form class="col d-flex" role="search" @submit.prevent="searchOrder">
      <input type="text" class="form-control" placeholder="Entrez un numéro de commande (ean ou sku à venir)" v-model="quicksearch">
    </form> -->

    <!-- Menu utilisateur -->
    <ul class="col-4 nav align-items-center justify-content-end">
      <li class="nav-item dropdown">
        <button class="nav-link dropdown-toggle text-white" href="#" id="userDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false" @click="loadUserStores">
          {{ user.firstname }}
        </button>
        <ul class="dropdown-menu dropdown-menu-end mt-3" aria-labelledby="userDropdown">
          <li><router-link class="dropdown-item" to="/users/me">Mon profil</router-link></li>
          <!-- <li><router-link class="dropdown-item" to="/users/settings">Paramètres</router-link></li> -->
          <li><hr class="dropdown-divider"></li>
          <li v-for="store in user.stores" :key="store.id" class="list-group-item">
            <a class="dropdown-item" href="#" @click="updateUserStore(store)">{{ store.name }}</a>
          </li>
          <li><hr class="dropdown-divider"></li>
          <li><a class="dropdown-item" href="#" @click="logout">Déconnexion</a></li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      quicksearch: null,
    };
  },
  computed: {
    ...mapGetters('cookie', ['user']),
  },
  methods: {
    ...mapActions('cookie', ['fetchUserStores', 'updateUserDefaultStore', 'logout']),
    loadUserStores() {
      if (!this.user.stores) {
        this.fetchUserStores();
      }
    },
    updateUserStore(store) {
      this.updateUserDefaultStore(store);
    },
    searchOrder() {
      if (this.quicksearch.trim() != '') {
        this.$router.push(`/orders/`);
        this.quicksearch = null;
      }
    }
  }
};
</script>

<style scoped>
.nav li:hover, 
.nav li.active {
  background: none;
}
.nav-link, 
.nav-link:focus {
  color: #fff;
}
.nav-link:hover {
  color: #ccc;
}
</style>
